import { t } from 'i18next'
import { useState, useEffect } from 'react'
import { useTenant } from 'src/app/hooks/context/context.hook'
import useErrorSnackBar from 'src/app/hooks/error-snack-bar/error-snack-bar'
import useReportGenerator, { ReportType, isReport } from 'src/app/hooks/report-generator/report-generator-hook'
import { DashboardPhase, DashboardReceptionReportField } from 'src/app/pages/common/dashboard/dashboard.types'
import { formatYYYYmmDD } from 'src/utils/date'
import ReportViewer from '../report-viewer'

type ReceptionReportViewerProps = {
  propertyId: string
  day: Date
  filter?: {
    name?: string
    group?: string
    phases?: DashboardPhase[]
  }
  sort?: {
    field: DashboardReceptionReportField
    dir?: 'asc' | 'desc'
  }
  open: boolean
  setClose: () => void
}

export default function ReceptionReportViewer(props: ReceptionReportViewerProps) {
  const { propertyId, day, filter, open, setClose, sort } = props
  const { id: tenantId } = useTenant()
  const [loading, setLoading] = useState(false)
  const [report, setReport] = useState<string | undefined>()
  const generateReport = useReportGenerator()
  const showError = useErrorSnackBar()

  useEffect(() => {
    const doReport = async () => {
      setLoading(true)
      const reportBlob = await generateReport({
        body: {
          tenantId: tenantId,
          propertyId: propertyId,
          day: formatYYYYmmDD(day),
          filters: filter,
          sort: sort,
        },
        type: ReportType.RECEPTION,
      })
      setLoading(false)
      if (isReport(reportBlob)) {
        setReport(reportBlob.file)
      } else {
        showError(reportBlob.message)
        setClose()
      }
    }
    doReport()
  }, [day, filter, tenantId, propertyId])

  return <ReportViewer isLoading={loading} title={t('pms.common.dashboard.reception_report.title')} open={open} setClose={setClose} reportFile={report} size="md" />
}
